<template>
    <section class="FullBleedHero" v-if="slice.primary.image.url">
        <SmartImage
            class="FullBleedHero__img"
            :url="slice.primary.image.url"
            :width="slice.primary.image.dimensions.width"
            :height="slice.primary.image.dimensions.height"
            :srcs="[{ width: 400 }, { width: 800 }, { width: 1440 }]"
            :as-bg="true"
        />
    </section>
</template>

<script setup lang="ts">
import { type Content } from '@prismicio/client'

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
defineProps(
    getSliceComponentProps<Content.FullBleedHeroSlice>([
        'slice',
        'index',
        'slices',
        'context',
    ]),
)
</script>

<style lang="scss">
.FullBleedHero {
    grid-column: 1 / span 24;
    margin-top: 8rem;

    @include large-up {
        margin-top: 11.25rem;
    }
}
</style>
